import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/MiniAppInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/web/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WalletProvider"] */ "/vercel/path0/web/src/lib/wallet.tsx");
